import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReferenceDataLabels } from '../../lib/constants/reference-data-labels';
import { ReferenceDataOptionLists } from '../../lib/constants/reference-data-option-lists';
import { Address } from '../../lib/models/api/address.model';
import { ValidationErrors } from '../../lib/models/validation/validation-errors';

@Component({
  selector: 'boi-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent {
  @Input() public address: Address;
  @Input() public validationErrors: ValidationErrors;

  @Output() public readonly isFindAddressOpenChange = new EventEmitter<boolean>();

  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public isFindAddressOpen = false;
  public isPostCodeInvalid: boolean;

  public selectAddress(address: Address): void {
    this.address.AddressLine1 = address.AddressLine1;
    this.address.AddressLine2 = address.AddressLine2;
    this.address.AddressLine3 = address.AddressLine3;
    this.address.County = address.County;
    this.address.Postcode = address.Postcode;
  }

  public postcodeToUpper(): void {
    this.address.Postcode = this.address.Postcode ? this.address.Postcode.toUpperCase() : undefined;
  }

  public postCodeSearchError(event: boolean): void {
    this.isPostCodeInvalid = event;
  }

  public openAddressFinder(): void {
    this.isPostCodeInvalid = false;
    this.isFindAddressOpen = true;
    this.isFindAddressOpenChange.emit(true);
  }
}
